import * as React from 'react'
function SvgOpen(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M34 18H22V6c0-1.2-.8-2-2-2s-2 .8-2 2v12H6c-1.2 0-2 .8-2 2s.8 2 2 2h12v12c0 1.2.8 2 2 2s2-.8 2-2V22h12c1.2 0 2-.8 2-2s-.8-2-2-2z"
				fill="currentColor"
				fillRule="evenodd"
			/>
		</svg>
	)
}
export default SvgOpen
